// System directives

"use client";

// System dependencies

import React from "react";

// Application dependencies

import FormSpinner from "@/components/form/formSpinner/FormSpinner";
import { getFormSpinnerSelector } from "@/redux/formSpinner/formSpinner.slices";
import { useAppSelector } from "@/redux/store.hooks";

// Props

const FormSpinnerProvider = () => {
  // Application state

  const { caption, isActive } = useAppSelector(getFormSpinnerSelector);

  // ---------------------------------------------------------------------------------------------------------------------------------------
  // Form interaction and rendering
  // ---------------------------------------------------------------------------------------------------------------------------------------

  return <FormSpinner caption={caption} isActive={isActive} />;
};

export default FormSpinnerProvider;
